import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

import { Input } from 'ui-components/components/input';

import { MarkAsShippedContext } from '../../../context';
import { stopPropagation } from '../../../helper';

import style from '../style.module.less';

const messages = defineMessages({
  trackingNumberPlaceholder: {
    description: 'Mark as shipped tracking number column placeholder',
    defaultMessage: 'Tracking Number',
    id: '6Ol6DI',
  },
});

const TrackingNumber = ({ fulfillmentPlanId }) => {
  const intl = useIntl();
  const {
    fulfillmentPlans: { [fulfillmentPlanId]: { trackingNumber } = {} },
    updateFulfillmentPlan,
  } = useContext(MarkAsShippedContext);

  const onChange = useCallback(
    (id) => {
      updateFulfillmentPlan(fulfillmentPlanId, 'trackingNumber', id);
    },
    [updateFulfillmentPlan, fulfillmentPlanId],
  );

  return (
    <div className={style['input-wrapper']} onClick={stopPropagation}>
      <Input
        className={style.input}
        data-testid={`${fulfillmentPlanId}-tracking-number-mark-as-shipped`}
        onChange={onChange}
        placeholder={intl.formatMessage(messages.trackingNumberPlaceholder)}
        value={trackingNumber}
      />
    </div>
  );
};

TrackingNumber.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default TrackingNumber;
